import { memo } from 'react';
import type { VoidFunctionComponent } from 'react';

import BowerIcon from './BowerIcon';
import CargoIcon from './CargoIcon';
import CocoapodsIcon from './CocoapodsIcon';
import CpanIcon from './CpanIcon';
import DebianIcon from './DebianIcon';
import FallbackIcon from './FallbackIcon';
import GitIcon from './GitIcon';
import GoIcon from './GoIcon';
import MavenIcon from './MavenIcon';
import NpmIcon from './NpmIcon';
import NugetIcon from './NugetIcon';
import PipIcon from './PipIcon';
import PubIcon from './PubIcon';
import RubygemsIcon from './RubygemsIcon';
import SwiftIcon from './SwiftIcon';

type Props = {
  fetcher: string;
};

const FetcherIcon: VoidFunctionComponent<Props> = ({ fetcher }) => {
  switch (fetcher) {
    case 'bower': return <BowerIcon />;
    case 'cargo': return <CargoIcon />;
    case 'cpan': return <CpanIcon />;
    case 'deb': return <DebianIcon />;
    case 'gem': return <RubygemsIcon />;
    case 'git': return <GitIcon />;
    case 'go': return <GoIcon />;
    case 'mvn': return <MavenIcon />;
    case 'npm': return <NpmIcon />;
    case 'nuget': return <NugetIcon />;
    case 'pip': return <PipIcon />;
    case 'pod': return <CocoapodsIcon />;
    case 'pub': return <PubIcon />;
    case 'swift': return <SwiftIcon />;
    default: return <FallbackIcon />;
  }
};

export default memo(FetcherIcon);
